import { render, staticRenderFns } from "./AddPriceOption.vue?vue&type=template&id=7f9a245e&"
import script from "./AddPriceOption.vue?vue&type=script&lang=js&"
export * from "./AddPriceOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports